import { useAsyncData, useNuxtApp } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { getOptionalEndpointTimeoutOptions } from '~/scopes/product-core/composables/useFetch/utils/getOptionalEndpointTimeoutOptions'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useFetchTechnicalSpecifications() {
  const nuxtApp = useNuxtApp()
  const { productId } = useUrlParams()
  const $httpFetch = useHttpFetch()

  return useAsyncData(
    () => `pp-technical-specifications-${productId}`,
    async () => {
      return $httpFetch(
        '/product-page/products/:productId/technical_specifications',
        {
          pathParams: {
            productId,
          },
          ...getOptionalEndpointTimeoutOptions(),
        },
      )
    },
    {
      lazy: true,
      dedupe: 'defer',
      getCachedData: (key) => nuxtApp.payload.data[key],
    },
  )
}
